import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ErrorCodeType } from '../../model/types/error-code-type';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery'
import { LoggerProvider } from '../../providers/logger/logger';

@Component({
  selector: 'rmt-submit-button',
  templateUrl: 'rmt-submit-button.html'
})
export class RmtSubmitButtonComponent {
  @ViewChild('container', { read: ElementRef }) container;
  @Input() form;
  @Input() color: string = 'primary';
  @Input() disable: boolean = false;
  @Input() size: string = 'btn-large';
  @Input() btnId:string;
  @Input() analyticsId: string;
  @Input() ignoreVisibleErrors: boolean = false;

  hasSubmitted: boolean = false;
  lastError;

  constructor(private translate: TranslateService) {
  }

  getCSSClass() {
    let cssClass = "";
    if(this.size) {
      cssClass = cssClass ? `${cssClass} ${this.size}` : this.size; 
    }

  return cssClass;
  }

  isDisabled() {
    this.lastError = null;
    // always look for the offending control, even when [disable] is already set - otherwise a form
    // that is invalid because of a hidden control gives us no way to tell which one it is
    const invalidControl = this.findInvalidControl();

    if (this.disable) {
      this.lastError = invalidControl ? 'Submit button is disabled - ' + invalidControl : 'Submit button is disabled';
      return true;
    }

    if (invalidControl) {
      this.lastError = invalidControl;
      return true;
    }
    if (this.ignoreVisibleErrors)
      return false;
    const checkIfErrorVisible = this.checkIfErrorVisible();
    if(checkIfErrorVisible)
      return checkIfErrorVisible;
    return false;
  }

  findInvalidControl() {
    if (!this.form)
      return null;
    let forms = [ this.form ];
    if (Array.isArray(this.form))
      forms = this.form;
    for (let i=0; i < forms.length; i++) {
      const form = forms[i];
      for (const id in form.controls) {
        const control = form.controls[id];
        if (!control.disabled && !control.valid) {
          if(control.value || control.validator) {
            let error = 'Control ' + id + ' is invalid';
            if (!id.toLowerCase().includes('password'))  // to also consider newPassword, confirmPassword, currentPassword
              error += ': ' + control.value;
            return error;
          }
        }
      }
    }
    return null;
  }

  checkIfErrorVisible() {
    const page = $(this.container.nativeElement).parents('.ion-page');
    if (!page || page.length === 0) {
      return false;
    }

    const pageel = page.get(0);
    const scroll = pageel.getElementsByClassName('scroll-content');
    let childs = pageel.getElementsByClassName('error-div');    
    if (childs && childs.length > 0) { // if errors are visible don't allow to continue
        return true;
    }
    return false;
  }

  reset() {
    this.hasSubmitted = false;
    if (this.form) {
      let forms = [ this.form ];
      if (Array.isArray(this.form))
        forms = this.form;
      for (let i=0; i < forms.length; i++) {
        const form = forms[i];
        form.reset();
        if (form['submitAttempts'])
          form['submitAttempts'] = null;
      }
    }
  }

  clickedContainer(ev) {
    let success = true;
    const page = $(this.container.nativeElement).parents('.ion-page');
    if (!page || page.length === 0) {
      LoggerProvider.info(this, 'Submit button deactivated: missing page');
      ev.stopPropagation();
      success = false;
      return;
    }

    const pageel = page.get(0);
    const scroll = pageel.getElementsByClassName('scroll-content');
    let childs = pageel.getElementsByClassName('rmt-error-flash');    
    if (childs && childs.length > 0) { // if errors are visible don't allow to continue
      LoggerProvider.info(this, 'Submit button deactivated: errors are visible', this.lastError);
      ev.stopPropagation();
      success = false;
    }
    else {
      childs = pageel.getElementsByClassName('rmt-error-show');
      if (childs && childs.length > 0) { // if errors are visible don't allow to continue
        LoggerProvider.info(this, 'Submit button deactivated: visible errors', this.lastError);
        ev.stopPropagation();
        success = false;
      }
    }

    window.setTimeout(() => {
      if (scroll && scroll.length > 0 && childs && childs.length > 0) {
        const child: any = childs[0];
        scroll[0].scrollTo({ left: 0, top: child.offsetTop - 100, behavior: 'smooth' });
      }
    }, 100);

    if (this.isDisabled()) {
      LoggerProvider.info(this, 'Submit button deactivated: disabled', this.lastError);
      ev.stopPropagation();
      success = false;
    }

    if (this.form) {
      let forms = [ this.form ];
      if (Array.isArray(this.form))
        forms = this.form;
      for (let i=0; i < forms.length; i++) {
        const form = forms[i];
        // if (!form['submitAttempts'])
        //   form['submitAttempts'] = 1;
        // else
        //   form['submitAttempts']++;
        this.hasSubmitted = true;
        if (!form.valid) {
          LoggerProvider.info(this, 'Submit button deactivated: form not valid', this.lastError);
          ev.stopPropagation();
          success = false;
        }
      }
    }

    if (success)
      LoggerProvider.info(this, 'Submit button clicked');
  }

  handleError(error) {
    if (error.errorCurrent && error.errorCurrent.key &&
        (error.errorCode === ErrorCodeType.ModelValidation || error.errorCode === ErrorCodeType.FieldValidation || error.errorCode === ErrorCodeType.RegexValidation)) {
      const errorId = error.errorCurrent.key.toLowerCase();
      let forms = [ this.form ];
      if (Array.isArray(this.form))
        forms = this.form;
      for (let i=0; i < forms.length; i++) {
        const form = forms[i];
        for (const id in form.controls) {
          if (id.toLowerCase() === errorId) {
            form.controls[id].setErrors({'incorrect': true});
            RmtPopupComponent.showErrorWithLogTranslation('global.generalValidationError');
            return true;
          }
        }
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-submit-button/rmt-submit-button.ts